module.exports = __webpack_public_path__ + "images/5e617b752b58ae53b07ad9a21239a58b.svg";